const CARDS_DATA = [
  {
    title: '当红小花绯闻对象身份曝光',
    desc: '近日有媒体拍到某当红小花与神秘男子深夜同返住所，男方身份疑似圈内知名制片人，引发网友热议。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20night%20scene%20with%20warm%20street%20lights%20and%20blurred%20background%2C%20mysterious%20atmosphere%2C%20cinematic%20street%20photography%2C%20dark%20urban%20setting%20with%20golden%20highlights%2C%20no%20faces%2C%20no%20text%2C%20editorial%20style&width=800&height=500&seq=cards-1-2026&orientation=landscape',
    tag: '明星恋情',
    tagColor: 'bg-primary-500',
  },
  {
    title: '热门综艺录制突发换人风波',
    desc: '据知情人透露，某档热播综艺节目因嘉宾档期冲突临时更换阵容，新加入的嘉宾能否胜任引发观众担忧。',
    img: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20empty%20chairs%20and%20dramatic%20spotlight%2C%20warm%20stage%20lighting%2C%20mysterious%20backstage%20atmosphere%2C%20cinematic%20composition%2C%20dark%20background%2C%20editorial%20photography%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=cards-2-2026&orientation=landscape',
    tag: '综艺爆料',
    tagColor: 'bg-accent-500',
  },
  {
    title: '知名歌手新专辑录制幕后',
    desc: '暌违三年的新专辑终于有了实质进展，多位知名音乐人参与制作，专辑风格或有大突破。',
    img: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20warm%20ambient%20lighting%2C%20microphone%20and%20instruments%20silhouette%2C%20professional%20audio%20equipment%2C%20dark%20cozy%20atmosphere%2C%20golden%20glow%2C%20editorial%20photography%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=cards-3-2026&orientation=landscape',
    tag: '音乐动态',
    tagColor: 'bg-secondary-500',
  },
  {
    title: '年度大片片酬分配内幕揭秘',
    desc: '某部即将上映的年度巨制，主演片酬分配方案流出，数字惊人引发圈内震动。',
    img: 'https://readdy.ai/api/search-image?query=Movie%20set%20with%20dramatic%20lighting%20and%20film%20equipment%2C%20cinematic%20production%20atmosphere%2C%20warm%20golden%20backlight%2C%20professional%20camera%20rig%20silhouette%2C%20dark%20background%2C%20editorial%20photography%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=cards-4-2026&orientation=landscape',
    tag: '影视揭秘',
    tagColor: 'bg-primary-500',
  },
  {
    title: '时尚盛典红毯造型全盘点',
    desc: '刚刚落幕的年度时尚盛典红毯环节精彩纷呈，多位女星造型大胆，引发时尚圈热烈讨论。',
    img: 'https://readdy.ai/api/search-image?query=Fashion%20runway%20with%20dramatic%20spotlights%20and%20red%20carpet%2C%20glamorous%20atmosphere%2C%20elegant%20dark%20background%20with%20golden%20accents%2C%20fashion%20show%20lighting%2C%20editorial%20photography%2C%20no%20text%2C%20no%20people%2C%20luxurious%20vibe&width=800&height=500&seq=cards-5-2026&orientation=landscape',
    tag: '时尚穿搭',
    tagColor: 'bg-accent-500',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-article-line text-primary-500 mr-2"></i>热门吃瓜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">当下最受关注的吃瓜内容推荐</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARDS_DATA.slice(0, 3).map((card, idx) => (
            <article
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className={`inline-block px-2.5 py-1 rounded-full ${card.tagColor} text-white text-[10px] font-bold mb-2`}>
                  {card.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}

          {CARDS_DATA.slice(3).map((card, idx) => (
            <article
              key={idx + 3}
              className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className={`inline-block px-2.5 py-1 rounded-full ${card.tagColor} text-white text-[10px] font-bold mb-2`}>
                  {card.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}